import { render, staticRenderFns } from "./Product220Page.vue?vue&type=template&id=763c35e2"
import script from "./Product220Page.vue?vue&type=script&lang=js"
export * from "./Product220Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports